import { toast } from "../components/ui/use-toast";
import api from "./api";
import { BASE_URL } from "./auth";

/**
 * 
 * @param slideId 
 * @description Updates the internal Slides object to reflect the live Google Slides document
Deletes slide if no longer exists
Adds/Deletes text & image placeholders
Updates preview image

Returns:

`404` not found

`200` Slide object if successfully reset

`204` no content if slide is deleted

`422` if PowerPoint slide sent
 */
export async function syncSingleSlide(
  slideId: string
): Promise<{ status: "updated" | "deleted" | "error" }> {
  try {
    const res = await api.get(`${BASE_URL}/slides/${slideId}/sync`);
    switch (res.status) {
      case 404:
        throw new Error("Slide not found");
      case 422:
        throw new Error("PowerPoint slides cannot be synced!");
      // case 204:
    }
    return {
      status:
        res.status === 200
          ? "updated"
          : res.status === 204
          ? "deleted"
          : "error",
    };
  } catch (error: any) {
    toast({
      title: "Slide Sync Status",
      description: error.message,
      variant: "destructive",
    });
    return { status: "error" };
  }
}
